var exports = {
  "Y": "tooltip__G7fjKw",
};

module.exports = exports;
